import { useEffect } from 'react';

export const useEventListener = (
  event: string,
  callback: EventListenerOrEventListenerObject,
  element?: HTMLElement | Window | Document
): void => {
  useEffect(() => {
    (element || document).addEventListener(event, callback);
    return () => (element || document).removeEventListener(event, callback);
  }, [event, callback, element]);
};
